import React from 'react';
import { useIntl } from 'react-intl';
import { FormProvider, useForm } from 'react-hook-form';
import { Grow } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import CustomDialog from '../../../Components/Dialog/CustomDialog';
import EmailWidget from './EmailWidget';
import CustomEmailActions from './CustomEmailActions';

const EmailWindow = function EmailWindow({
  open,
  close,
  onSubmit = () => {},
  defaultEmail = null,
  replyData = null,
}) {
  const methods = useForm();
  const intl = useIntl();
  return (
    <FormProvider {...methods}>
      <CustomDialog
        title={replyData ? intl.messages.REPLY_EMAIL : intl.messages.NEW_EMAIL}
        open={open}
        noBackdrop
        close={close}
        maxWidth="lg"
        fullWidth
        icon={<EmailIcon />}
        transition={Grow}
        transitionDuration={600}
        components={{
          actions: (
            <CustomEmailActions
              activityId={replyData?.id || null}
              messageId={replyData?.messageId || null}
              close={close}
            />
          ),
        }}
        onSubmit={(data) => onSubmit(data)}
        enctype="multipart/form-data"
      >
        <EmailWidget defaultEmail={defaultEmail} replyData={replyData} />
      </CustomDialog>
    </FormProvider>
  );
};

export default EmailWindow;
